import React, {useEffect, useState} from 'react';
import {DEFAULT_PAGE_SIZE, LOCAL_STORAGE_USER_LOGIN_INFO} from '@app/constants/Common';
import QuickSearchJob from "@pages/job/list/QuickSearchJob";
import OrderListByUpdatedTime from "@app/components/OrderListByUpdatedTime";
import RunJobMainModal from "@pages/job/runjob/RunJobMainModal";

export const PipelineListMode = {
    PIPELINE_LIST: 1,
    RUN_JOB: 2,
}

const RunJobListTable = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [numberPages, setNumberPages] = useState(1);
    const [runJobList, setRunJobList] = useState([]);
    const [searchCondition, setSearchCondition] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [selectRunJob, setSelectRunJob] = useState({});
    const [showRunJobModal, setShowRunJobModal] = useState(false);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const {runJobs} = props
    const {totalCount} = props
    const {onSearch} = props

    const nextPage = () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            searchCondition.page = currPage
            onSearch(searchCondition)
        } else {
            currPage = numberPages
        }
        setCurrentPage(currPage)
    };

    const onSearchClick = (condition) => {
        if (!condition.page) {
            condition.page = currentPage
        }

        condition.size = DEFAULT_PAGE_SIZE
        setSearchCondition(condition)
        return onSearch(condition)
    };

    const backPage = () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            searchCondition.page = currPage
            onSearch(searchCondition)
        } else {
            currPage = 0
        }
        setCurrentPage(currPage)
    };

    useEffect(() => {
        setRunJobList([...runJobs])
    }, [runJobs])

    useEffect(() => {
        setNumberPages(Math.ceil(totalCount/DEFAULT_PAGE_SIZE))
    }, [totalCount])

    const openJobDetail = (jobId) => {
        if (!jobId) {
            jobId = runJobList[0].job_id
        }
        const win = window.open(`/job/edit/${jobId}`, "_blank");
        win.focus();
    }

    const openRunJobModal = (runJob) => {
        setSelectRunJob({...runJob})
        setShowRunJobModal(true)
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Danh sách Job ({totalCount})</h3>
                    {totalCount > 0 &&
                    <h3 className='card-title text-bold ml-3'>Page: {currentPage}/{numberPages}</h3>
                    }
                    <div className='card-tools'>
                        {/*<OrderListByUpdatedTime onChange={(orderBy) => {*/}
                        {/*    searchCondition.order_by = orderBy*/}
                        {/*    onSearch(searchCondition)*/}
                        {/*}}/>*/}
                        {numberPages > 1 &&
                        <ul className='pagination pagination-sm float-right mt-2 ml-5'>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => backPage()}>&laquo;</button>
                            </li>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => nextPage()}>&raquo;</button>
                            </li>
                        </ul>
                        }
                    </div>
                </div>
                <div className='card-body table-responsive p-0' style={{minHeight: 300}}>
                    <table
                        className='table table-hover table-bordered text-nowrap text-center'
                    >
                        <thead>
                        <tr>
                            <th>No.</th>
                            <th>Job ID</th>
                            <th>Run job date</th>
                            <th>Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        {runJobList && runJobList.length > 0 && runJobList.map((runJob, index) => (
                            <tr key={`run_job_${index}`}>
                                <td>{runJob.no ? runJob.no : index + 1}</td>
                                <td>
                                    <a href="javascript:void(0)" onClick={() => openJobDetail(runJob.job_id)}>
                                        {runJob.job_id}
                                    </a>
                                </td>
                                <td>{runJob.created_date_time}</td>
                                <td>
                                    <div className="btn-group">
                                        <button type={"button"} onClick={() => openRunJobModal(runJob)}
                                                className={"btn btn-default"}>Run job</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className='card-footer'>
                    <div className='card-tools'>
                        {numberPages > 1 &&
                        <ul className='pagination pagination-sm float-right'>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => backPage()}>&laquo;</button>
                            </li>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => nextPage()}>&raquo;</button>
                            </li>
                        </ul>
                        }
                    </div>
                </div>
            </div>
            {showRunJobModal &&
            <RunJobMainModal candidateIds={[]}
                             jobId={selectRunJob.job_id}
                             onClose={() => setShowRunJobModal(false)}
                             isShow={showRunJobModal}/>
            }
        </>
    );
};

export default RunJobListTable;
